import { ActionableItemState } from 'app/shared/models/actionable-item-state';
import { IIconActionButton } from 'app/shared/interfaces/IIconActionButton.interface';
import { ContactListItemModel } from './contact-list-item.model';

export class ContactListItemViewModel extends ActionableItemState {
  activateToggleButton: IIconActionButton;

  constructor(dataModel: ContactListItemModel) {
    super();

    this.dataModel = dataModel;
    const activateToggleIcon = dataModel.isActive === true ? 'block' : 'check';
    const activateToggleDescription = dataModel.isActive === true ? 'Deactivate the item' : 'Activate the item';

     const activateToggleEnabled = dataModel.isActive ? dataModel.canDeactivate : true;

    this.activateToggleButton = {
      visible: true,
      enabled: true,
      actionEnabled: activateToggleEnabled,
      actionDisabledMessage: activateToggleEnabled ? '' : dataModel.cannotDeactivateReason,
      iconName: activateToggleIcon,
      actionName: 'activateToggle',
      hoverText: activateToggleDescription,
      class: '',
      buttonText: ''
    };

    this.processActions.push(this.activateToggleButton);
  }
}
